import Model from './Model';

class Subscription extends Model {
  getSubscriptionId() {
    return this.attrs.subscriptionId;
  }

  setSubscriptionId(value) {
    this.attrs.subscriptionId = value;
    return this.attrs;
  }

  getStatus() {
    return this.attrs.status;
  }

  setStatus(value) {
    this.attrs.status = value;
    return this.attrs;
  }

  getPlanId() {
    return this.attrs.planId;
  }

  setPlanId(value) {
    this.attrs.planId = value;
    return this.attrs;
  }

  getEndDate() {
    return this.attrs.endDate;
  }

  setEndDate(value) {
    this.attrs.endDate = value;
    return this.attrs;
  }

  getStartDate() {
    return this.attrs.startDate;
  }

  setStartDate(value) {
    this.attrs.startDate = value;
    return this.attrs;
  }

  getType() {
    return this.attrs.type;
  }

  setType(value) {
    this.attrs.type = value;
    return this.attrs;
  }
}

export default Subscription;
